<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2023/08/01

    Historial de Modificaciones
    // Fecha Modificación: 
    // Modificación: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario  Register User -->
        <v-form ref="formRegisterUser" lazy-validation>
            <v-dialog v-model="estadoComp" persistent scrollable max-width="90%">

                <v-card>
                    <v-card-title class="modal_title">
                        <v-row class="d-flex justify-space-between py-2">
                            {{ formTitle }}
                            <v-btn fab dark x-small class="btn_style3"   @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-row>
                           
                            <v-col cols="12" sm="12" md="12" class="pb-0">
                                <v-alert dense border="left"  class="text-center color_main"   dark>
                                    <h3>Validar documento y correo</h3>
                                </v-alert>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-select label="Tipo de Documento" v-model="Datos.id_tipo_documento"
                                    :items="TipoDocumentos" item-value="id" item-text="desc_tipo_documento"
                                    :rules="[validation.selectReq]" >
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-text-field  label="Número de Documento" v-model="Datos.numdoc_persona" :rules="[validation.required, validation.min4, validation.max12]"
                                    @keypress="restrictCharsNumeros($event)" ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-text-field label="Correo Electrónico" v-model="Datos.correo_persona" type="email" 
                                    :rules="[validation.email_null, validation.max50]" ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-btn class="btn_block_style2" tile    @click="generarCodigo(Datos)">Generar Codigo por email</v-btn>
                            </v-col>
                            
                            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                                <v-text-field  label="Ingrese código de validación" v-model="Datos.codigo_validacion" :rules="[validation.required, validation.min4, validation.max12]" @keypress="restrictCharsNumeros($event)"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="3" lg="auto" class="py-0">
                                <v-btn class="btn_block_style2" tile v-if="bloquearInput" @click="ClearData()">Limpiar Datos</v-btn>
                            </v-col>
                            <v-col cols="12" sm="6" md="3" lg="auto" class="py-0">
                                <v-btn class="btn_block_style2" tile  v-if="bloquearInput" @click="ValidateUser(Datos.codigo_validacion);">Validar Datos</v-btn>
                            </v-col>
                            
                            <v-col cols="12"  class="pt-0 red--text">
                                Se enviara un codigo de verifcación a su correo, para continuar con los demas datos
                            </v-col>
                        </v-row>


                        <!-- REGISTER USER -->
                        <v-row v-if="createUser">

                            <v-col cols="12" sm="12" md="12" class="pb-0">
                                <v-alert dense border="left"  class="text-center color_main" dark>
                                    <h3>Datos Personales</h3>
                                </v-alert>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                                <v-text-field label="Nombres" type="text" v-model="Datos.nombre_persona" :rules="[validation.required, validation.max50]" ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                                <v-text-field label="Apellidos" type="text" v-model="Datos.ape1_persona" :rules="[validation.required, validation.max40]" ></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-select label="Sexo" v-model="Datos.sexo_persona"   
                                    :items="sexos" item-value="abbr" item-text="nombre"
                                    :rules="[validation.selectReq]" >
                                </v-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-menu v-model="menu2" :close-on-content-click="false"
                                    transition="scale-transition" offset-y max-width="290px" min-width="290px">

                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="computedDateFormatted" label="Fecha de Nacimiento"
                                            v-on="on" :rules="[validation.required]" readonly>
                                        </v-text-field>
                                    </template>

                                    <v-date-picker v-model="Datos.fecnac_persona" no-title @input="menu2 = false" 
                                        :disabled="bloquearInput" :max="getEndDate">
                                    </v-date-picker>
                                </v-menu>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-autocomplete v-model="Datos.id_pais_nacimiento" :items="Paises" item-text="nombre_pais" item-value="id"
                                    :rules="[validation.selectReq]" label="País de Nacimiento" >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-autocomplete label="Nacionalidad" v-model="Datos.id_nacionalidad" 
                                    :items="Paises" item-text="nombre_pais" item-value="id"
                                    :rules="[validation.selectReq]"  >
                                </v-autocomplete>
                            </v-col>
                            <!--
                            <v-col cols="12" sm="4" md="4" lg="3" class="py-0">
                                <v-radio-group row  v-model="Datos.estado_usuario" label="Estado ">
                                    <v-radio :label="`Activo`" :value="1" color="teal"></v-radio>
                                    <v-radio :label="`Inactivo`" :value="0" color="error"></v-radio>
                                </v-radio-group>
                            </v-col> -->
                            <!--
                            <v-col cols="12" sm="12" md="12" class="py-0">
                                <v-alert dense border="left"  class="text-center; color_main" dark>
                                    <h3>Datos de Usuario</h3>
                                </v-alert>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                                <v-text-field label="Login de Usuario" v-model="Datos.usu_usuario" 
                                    type="text" :rules="[validation.required, validation.max40]"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="4" class="py-0" v-if="this.parametros.evento=='add'">
                                <v-text-field label="Contraseña" v-model="Datos.password_usuario"
                                    :type="show ? 'text' : 'password'"  :append-icon="show ? 'fa-eye' : 'fa-eye-slash'"
                                    :rules="[validation.max20]"
                                    class="input-group--focused" @click:append="show = !show" >
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="4" class="py-0">
                                <v-select label="Perfil" v-model="Datos.id_perfil"
                                    :items="Perfil" item-value="id" item-text="descripcion_perfil"
                                    :rules="[validation.selectReq]" >
                                </v-select>
                            </v-col>
                            -->


                              <!-- ubicacion usuarios -->

                              <v-col cols="12" sm="12" md="12" class="pb-0">
                                <v-alert dense border="left"  class="text-center;  color_main" dark>
                                    <h3>Datos de Ubicación y Contacto</h3>
                                </v-alert>
                            </v-col>


                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                
                                <v-autocomplete :label="$t('ubicacion.ubicacion1')" v-model="Datos.id_ubicacion1"
                                    :items="Ubicacion1" item-text="nombre_ubicacion1" item-value="id"
                                    @change="loadUbicacion2(id_pais, Datos.id_ubicacion1)"
                                    :rules="[validation.selectReq]" >
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-autocomplete :label="$t('ubicacion.ubicacion2')" v-model="Datos.id_ubicacion2" 
                                    :items="Ubicacion2" item-value="id" item-text="nombre_ubicacion2"
                                    @change="loadUbicacion3(id_pais, Datos.id_ubicacion2)"
                                    :rules="[validation.selectReq]" >
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-autocomplete :label="$t('ubicacion.ubicacion3')" v-model="Datos.id_ubicacion3" 
                                    :items="Ubicacion3" item-text="nombre_ubicacion3" item-value="id"
                                    :rules="[validation.selectReq]" >
                                </v-autocomplete>
                            </v-col>


                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-text-field label="Teléfono" v-model="Datos.telf_persona" 
                                    type="number"  @keypress="restrictCharsNumeros($event)" 
                                    :rules="[validation.max12]" >
                                </v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-text-field label="Correo Electrónico" v-model="Datos.correo_persona" type="email" 
                                    :rules="[validation.email_null, validation.max50]" ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="4" lg="3" class="py-0">
                                <v-text-field  label="Dirección" v-model="Datos.direc_persona" 
                                    :rules="[validation.max150]" ></v-text-field>
                            </v-col>
                            <!-- fin ubicacion usuarios -->

                        </v-row>
                         

                        
                    
                    </v-card-text>


                    <v-divider></v-divider>
                    

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="btn_style3" dark tile @click="dialog=false">Cancelar</v-btn>
                        <v-btn class="btn_block_style2" tile v-if="this.parametros.evento=='update'" @click="saveItem();">Guardar Cambios</v-btn>
                        <v-btn class="btn_block_style2" tile v-if="this.createUser" @click="saveItem();">Guardar</v-btn>
                 
                    </v-card-actions>
                    <v-card-text>
                           
                        <span v-if="test">
                    <code>TipoDocumentos :{{TipoDocumentos}}</code><br>
                    <code>Paises :{{Paises}}</code>
                   
                    <!--
                         <code>Paises :{{Paises}}</code>
                        <code>Datos :{{Datos}}</code>
                        <code>Parametros :{{parametros}}</code>
                    -->
                </span>
                    </v-card-text>

                </v-card>
                
            </v-dialog>
                  
        </v-form>

        <!-- fin modal del Usuario -->

        

    </div>
</template>

<script>

    import axios,  { API_URL } from '@/helpers/axios'
    import { validation } from "@/helpers/validator.js";
    import {mapMutations } from 'vuex';

    export default {
        name:'RegisterUser',
        
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },


        // data: () => ({
        // data: (vm) => ({
        data: (vm) => ({
       
            session: sessionStorage, // variables de sesion del usuario
            rutaServer: API_URL,
            ////////////////////////////////////////////////////////

            // Avatar  Persona imagen
            previewImgAvatar: '',
            imageSaveAvatar: '',

            //// ARREGLO PARA CAMPOS DE  EDITAR O AGREGAR USUARIOS
            
            Datos:[],
            test: false,

            formTitle: "NUEVO INGRESO",
            id_pais : 196, // Venezuela, Peru 145
            
            // pais por default VENEZUELA
            Empresa:[], 
            TipoDocumentos:[],
     
            Perfil:[],
            Licencia:[],
            LicenciaTipo:[],

            Paises:[],

            //-------Departamentos-----------
            Ubicacion1:[],
            //-------provincias--------------
            Ubicacion2:[],
            //-------Distritos--------------
            Ubicacion3:[],


            //---------validacion password--
            show: false,
            bloquearInput: false,
            createUser : false,
            //--------sexo------------------
            sexos:[
                {nombre:'Masculino',abbr:'M'},
                {nombre:'Femenino',abbr:'F'},
            ],

            
             //-- funciones del date picker de fecha
            dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
            menu2: false,

            
        }),


        mounted() {
            this.loadMain()
        },

        //computadas
        computed: {
         
            validation() {
                return validation;
            },

          // Maxima Fecha Calendario
            getEndDate(){
                return  new Date().toISOString().substr(0, 10)               
            },

           computedDateFormatted () {
                return this.formatDate(this.Datos.fecnac_persona)
            },

           // AVATAR PARA USUARIOS //    
            avatarImg() {

                if(this.Datos.ruta_avatar_persona){
                    return (this.rutaServer+this.Datos.ruta_avatar_persona+this.Datos.avatar_persona)
                }else{
                    return null
                }
            },
 
            
             // Maxima Fecha Calendario
            maxDate(){
                return  new Date().toISOString().substr(0, 10)               
            },

          

        },

        
        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp: function () {
                if(this.estadoComp){

                    this.loadMain()
                    
                }else{
                    this.limpiarForm()
                }
            }
        },
        

        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ...mapMutations('loading', ['viewLoading', 'closeLoading']),
       
            ////////////////////////////////////////////////////////

            //  ------- Cargar todos los registros principales al iniciar el componente   --------
            async loadMain(){
                this.limpiarForm() 
                this.resetValidation()     

                this.getQuery(this.id_pais)

            },



            async getQuery(id_pais){
                try{

                    let response = await axios.get(`/sistema/usuario/getQuery/pais/${id_pais}`)
                    this.Empresa        = response.data.empresa
                    this.TipoDocumentos = response.data.tipoDocumento       
                    this.Paises         = response.data.pais
                    this.Ubicacion1     = response.data.ubicacion1
                    this.Perfil         = response.data.perfil

                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },
            

      
            limpiarForm(){
                
                

                let dataForm = {id:0, id_empresa:0, id_persona:0, 
                    id_tipo_documento:0, id_perfil:0, numdoc_persona:'',
                    ape1_persona:'Garcia', ape2_persona:'Castillo', nombre_persona:'wuil',
                    sexo_persona:'M', fecnac_persona:'2020-01-01', id_nacionalidad:0,
                    id_pais_nacimiento:0, id_pais : this.id_pais, id_ubicacion1:0,
                    id_ubicacion2:0, id_ubicacion3:0, telf_persona:'',
                    correo_persona:'wuilmergarciac@gmail.com', direc_persona:'VALENCIA EDO CARABOBO', avatar_persona:'',
                    ruta_avatar_persona: null, estado_persona:0, id_usuario:this.session.id,
                    id_licencia : 0, id_licencia_tipo : 0, fecha_fin:null,
                    usu_usuario:'', password_usuario:null, estado_usuario:1,
                    webmaster:false, 
                    codigo_validacion: 123456
                }
    

            

                
                this.Datos = dataForm
                this.resetValidation()
                this.previewImgAvatar = null
                this.show = false
                this.bloquearInput = false
                this.createUser = false
             
            },

           //  ------- input tipo fecha  --------
            formatDate (date) {
                if (!date) return null

                const [year, month, day] = date.split('-')
                return `${day}/${month}/${year}`
            },



            resetValidation() {
                this.$refs.formRegisterUser.resetValidation()
            },

            async generarCodigo(datos){                               
                
                this.bloquearInput = true
                if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(datos.correo_persona) == false ){
                    this.setEnviarMens({tipo:"W", mensaje: `Ingrese un coreo electrónico valido`, tiempo:null})
                    this.bloquearInput = false
                    return
                }

                if ( datos.id_tipo_documento == 0 ){                    
                    this.setEnviarMens({tipo:"W", mensaje: `Seleccione tipo de documento`, tiempo:null})  
                    this.bloquearInput = false
                    return                }

                if (datos.numdoc_persona == '' || datos.numdoc_persona == null ) {
                    this.setEnviarMens({tipo:"W", mensaje: `Ingrese un numero documento valido`, tiempo:null})
                    this.bloquearInput = false
                    return
                }
                
                if ( datos.numdoc_persona.length < 4 ){
                    this.setEnviarMens({tipo:"W", mensaje: `Ingrese un numero documento valido`, tiempo:null})
                    this.bloquearInput = false
                    return
                }                

                try{                    

                    this.viewLoading({})
                    let response = await axios.get(`/sistema/usuario/validarPreIngreso/tipoDocumento/${datos.id_tipo_documento}/documento/${datos.numdoc_persona}/correo/${datos.correo_persona}`)
                    let resp = response.data
                    console.log(resp)
                    this.closeLoading()
                    if(resp.error){
                        this.bloquearInput = false
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})    
                    }
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        this.bloquearInput = false
                        this.closeLoading()
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },


            async ClearData(){  
                this.resetValidation()
                this.bloquearInput = false  
                this.Datos.id_tipo_documento =  ""
                this.Datos.correo_persona = ""
                this.Datos.numdoc_persona   = ""
            },

            async ValidateUser(codigo){  

                this.createUser = false

                if ( this.bloquearInput == false ){
                    this.setEnviarMens({tipo:"W", mensaje: `Debe de  generar un codigo por email`, tiempo:null})
                    return
                }

                if ( !codigo){
                    this.setEnviarMens({tipo:"W", mensaje: `Debe de ingresar el codigo de validacion enviado al correo`, tiempo:null})
                    return
                }
                
                if ( codigo < 4 ){
                    this.setEnviarMens({tipo:"W", mensaje: `Ingrese un codio valido`, tiempo:null})
                    return
                }

                if ( codigo != 123456 ){
                    this.setEnviarMens({tipo:"W", mensaje: `El codigo ingresado no es valido`, tiempo:null})
                    return
                }  
                
                
                this.createUser = true
                this.setEnviarMens({tipo:"W", mensaje: `Crear información de los usuarios`, tiempo:null})

                // this.Datos.numdoc_persona = this.parametros.num_doc
                // this.Datos.usu_usuario = `${this.parametros.num_doc}`
                // this.Datos.usu_usuario = `${this.Datos.numdoc_persona}-${this.session.id_empresa}` 
                // this.getQuery(this.id_pais)
            
            },



            async saveItem(){
                if (this.$refs.formRegisterUser.validate()) {

                    try{
                        //let params = this.Datos

                          //console.log(` VALOR A FILTAR: ${JSON.stringify(this.Datos.id_empresa)} DATOS PAIS  ${JSON.stringify(this.Datos.id_pais)}, ID PAIS  ${JSON.stringify(arrColegio[0].id_pais)}`);
                        let    res = await axios.post("/sistema/usuario/preingreso",{user:this.Datos})

                         // si existe una imagen preview y la imagen a enviar al servidor, Guarda el avatar
                        // SAVE AVATAR
                        /*
                        if((this.previewImgAvatar) && (this.imageSaveAvatar)){
                            this.saveAvatar()
                        } 
                        */

                        if(res.data.messageT== "S"){
                            this.limpiarForm()
                            // this.$emit('reloadComp','usuario')                            
                        }

                        this.setEnviarMens({tipo:`${res.data.messageT}`, mensaje: `${res.data.message}`, tiempo:6000})
                    }

                   catch(e){
                        if (e.response) {
                            let resp = e.response.data
                            console.log(resp)
                            this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                        }
                    }
                }

            },

            
         

            // guardar imagen
            async saveAvatar(){ 

                try {

                    let formData = new FormData();
                    formData.append('subirArchivo', this.imageSaveAvatar)
                    formData.append('id_us_ing', this.session.id)
                    formData.append('id_persona', this.Datos.id_persona)
                    formData.append('n_documento', this.Datos.numdoc_persona)
                    formData.append('archivo_old', this.Datos.avatar_persona)
                    let resp = await axios.post( 'archivo/sistema/avatar',
                        formData,
                        {
                            headers: {'Content-Type': 'multipart/form-data' }
                        })

                         console.log(resp)
                    // this.$emit('reloadComp','usuario')
                    this.limpiarForm()

                } catch (error) {
                    console.log(error);
                    this.setEnviarMens({tipo:"E", mensaje: `Error en Subir Imagen`, tiempo:null})                    
                    // this.$emit('reloadComp','usuario')  
                }
               
            },


            /////////////////////////////////////////
             ///    SUBIR LOGO AVATAR PERSONA      ///
            
            // contenedor del avatar del colegio
            pickAvatar () {
                // activar imput tipo file 
                this.$refs.imageAvatar.click ()
            },


            // Seleccion del archivo por el usuario
            onFileAvatar (e) {
                const files = e.target.files || e.dataTransfer.files;

                if (!files.length) return;
                // crea imagen temporar para visualizar
                this.createImageAvatar(files[0]);

                if(files[0] !== undefined) {
                      this.imageSaveAvatar = files[0] // this is an image file that can be sent to server...
                }
            },

            // funcion para crear una imagen temporal
            createImageAvatar(file) {

                var reader = new FileReader();            
                reader.onload = e => { 
                    this.previewImgAvatar = e.target.result;
                };
                reader.readAsDataURL(file);
            },
           



            async loadUbicacion1(id_pais){
                //console.log(` load Ubicacion1 ${id}`)
                try{
                    let params = {filtro:{id_pais}}
                    let response = await axios.post("/sistema/divPolitica/ubicacion1", params)
                    this.Ubicacion1 = response.data;

                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }

            },


            //-------obtener provincias del departamento
            async loadUbicacion2(id_pais, id_ubicacion1){
                
                console.log(`PAIS: ${id_pais}, UBICACION ${id_pais}`)
                try{
                    let params = {filtro:{id_pais, id_ubicacion1}}
                    let response = await axios.post("/sistema/divPolitica/ubicacion2", params)
                    this.Ubicacion2 = response.data

                }
                 catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },


            //-------obtener provincias del departamento
            async loadUbicacion3(id_pais,id_ubicacion2){
                
                try{
                    let params = {filtro:{id_pais, id_ubicacion2}}
                    let response = await axios.post("/sistema/divPolitica/ubicacion3/",params)
                    this.Ubicacion3 = response.data
                    //this.Datos.id_ubicacion3 = null
                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },




            // validaciones
            //#############Solo numeros
            restrictCharsNumeros: function($event) {
                if ($event.charCode === 0 || /\d/.test(String.fromCharCode($event.charCode))) {
                    return true
                }
                else {
                    $event.preventDefault();
                }
            },


            // restrictCharsLetras1
            //#############Solo letras
            restrictCharsLetras: function($event) {
                if ($event.charCode === 0 || /"^[a-zA-Z ]+$" /.test(String.fromCharCode($event.charCode))) {
                    return true
                }
                else {
                    $event.preventDefault();
                }
            },


        },
    }
</script>


<style scoped>

    .fondo_add_img{
        padding-left: 0;
        padding-right: 0;
        margin-left: 0;
        margin-right: 0;
        cursor:pointer; cursor: hand;
        border: 4px solid #FFF;
        border-color: #474545;
        color: #524f4f;
    }

</style>